<eretail-modal class="position-relative" [isCloseable]="true">
  <eretail-content-wrapper-header title="Alterar Senha"> </eretail-content-wrapper-header>

  <eretail-field
    class="eretail-form-sm mb-1"
    id="currentPassword"
    type="passwordWithToggle"
    [control]="currentPassword"
    label="Senha atual"
  ></eretail-field>
  <!-- <app-form-error [control]="currentPassword" [errorMessages]="{required: 'Informe a senha atual'}"></app-form-error> -->

  <eretail-field
    class="eretail-form-sm mb-1"
    id="new-password"
    type="passwordWithToggle"
    [control]="newPassword"
    [Validations]="[{type: 'min', message: 'Minimo de 8 caracteres', value: ' 8'}]"
    label="Nova senha"
  ></eretail-field>
  <div class="ms-3 mb-1">
    <app-form-error
      [control]="newPassword"
      [errorMessages]="{
        strongPassword:
          'A senha deve conter oito letras, incluindo letra maiúscula, minúscula, número e caractere especial'
      }"
    ></app-form-error>
  </div>

  <eretail-field
    class="eretail-form-sm mb-3"
    id="confirmPassword"
    type="passwordWithToggle"
    [control]="confirmPassword"
    label="Confirmar Senha"
  ></eretail-field>

  <app-button buttonClass="bt-primary w-100" (click)="onSubmit()" class="w-100"> Salvar </app-button>
</eretail-modal>
